<script>
  import { domainName, record } from '../stores.js';
</script>

<div class="record-box record-raw">
  <div id="headingRaw" class="box-label">
    <h5>SPF Record Found: <a class="link-arrow" href="https://{$domainName}" target="_blank">{$domainName}</a></h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseRaw" aria-expanded="true" aria-controls="collapseRaw" aria-label="Close"></button>
  </div>
  <div id="collapseRaw" class="box-detail collapse show" aria-labelledby="headingRaw">
    <div class="color-box">
      <p>{$record.raw}</p>
    </div>
  </div>
</div>

<style>

</style>
